export default __webpack_public_path__ + "static/media/openingscreenshottablet.373a78c4.png";